import axiosInstance from '@/utils/api.js'

var state = {
  access_cards: []
}

var getters = {
  ACCESS_CARDS: (state) => {
    return state.access_cards
  }
}

var mutations = {
  SET_ACCESS_CARDS: (state, payload) => {
    state.access_cards = payload || []
  }
}

var actions = {
  GET_ACCESS_CARDS: async (context, payload) => {
    let result = await axiosInstance.get('/users/access_cards?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_ACCESS_CARDS', result.data)
    }
  },
  CREATE_ACCESS_CARDS: (context, payload) => {
    return axiosInstance.post('/users/access_card', payload)
  },
  DELETE_ACCESS_CARDS: (context, payload) => {
    return axiosInstance.delete('/users/access_card?card_id=' + payload.card_id + '&card_number=' + payload.card_number)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/accessCards.js